import { gql } from '@apollo/client';

const UPDATE_FIGURE = gql`mutation updateFigure(
	$figureId: Int!
	$versionId: Int!
	$figureData: String
	$commentIds: [Int!]
) {
	resourceComments {
		updateFigure(
			figureId: $figureId
			resourceVersionId: $versionId
			figureData: $figureData
			commentIds: $commentIds
		) {
			author
			avatarUrl
			connectedCommentId
			created
			figureData
			id
			resourceVersionId
			userId
		}
	}
}`;

export default UPDATE_FIGURE;
